import type { StreamResponse } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { getInteractionModeExecutedFromMessage } from './getInteractionModeExecutedFromMessage';

export const getInteractionModeExecutedFromStreamResponse = (
	streamResponse?: Pick<StreamResponse, 'message'> | null,
): string | undefined => getInteractionModeExecutedFromMessage(streamResponse?.message?.message);
